"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStruct = exports.OrderProductStruct = void 0;
const superstruct_1 = require("superstruct");
const curency_1 = require("./curency");
exports.OrderProductStruct = (0, superstruct_1.type)({
    productId: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    quantity: (0, superstruct_1.number)(),
    imageFile: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    price: (0, superstruct_1.number)(),
    currency: curency_1.CurrencyStruct,
});
exports.OrderStruct = (0, superstruct_1.type)({
    inventoryId: (0, superstruct_1.string)(),
    products: (0, superstruct_1.array)(exports.OrderProductStruct),
});
exports.OrderProductStruct.type = 'OrderProduct';
exports.OrderStruct.type = 'Order';
//# sourceMappingURL=order.js.map